// src/components/footer/Footer.styled.tsx
import styled from "styled-components";
import { theme } from "../../styles/theme";

export const FooterContainer = styled.footer`
  background: rgba(10, 14, 26, 0.85);
  backdrop-filter: blur(16px);
  padding: ${theme.spacing.xl} ${theme.spacing.xl};
  border-top: 1px solid ${theme.colors.cardBorder};
  box-shadow: ${theme.shadows.lg};
  transition: ${theme.transitions.default};
  width: 100%;

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing.lg} ${theme.spacing.lg};
  }
`;

export const FooterContent = styled.div`
  max-width: ${theme.sizes.maxWidth};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.xl};
  width: 100%;

  @media (min-width: ${theme.breakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Copyright = styled.p`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.textSecondary};
  text-align: center;
  margin: 0;
  font-family: ${theme.fonts.main};
  letter-spacing: 0.02em;
  line-height: ${theme.lineHeights.normal};

  @media (min-width: ${theme.breakpoints.md}) {
    text-align: left;
  }
`;

export const SocialLinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xl};
  flex-direction: row-reverse;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.md};

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: ${theme.borderRadius.full};
    background: rgba(30, 144, 255, 0.12);
    color: ${theme.colors.primaryLight};
    border: 2px solid ${theme.colors.cardBorder};
    transition: all ${theme.transitions.default};
    position: relative;
    overflow: hidden;

    /* Efeito de brilho */
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0;
      height: 0;
      border-radius: 50%;
      background: rgba(30, 144, 255, 0.3);
      transform: translate(-50%, -50%);
      transition: width 0.5s, height 0.5s;
    }

    &:hover {
      background: ${theme.colors.primary};
      color: white;
      transform: translateY(-4px) scale(1.05);
      box-shadow: ${theme.shadows.neon};
      border-color: ${theme.colors.primary};

      &::before {
        width: 100px;
        height: 100px;
      }
    }

    &:active {
      transform: translateY(-2px) scale(1);
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.primary};
      outline-offset: 3px;
    }

    i {
      font-size: ${theme.fontSizes.xl};
      z-index: 1;
    }
  }
`;

export const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  font-family: ${theme.fonts.main};
  font-weight: ${theme.fontWeights.semibold};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text};
  background: rgba(30, 144, 255, 0.15);
  border: 2px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.lg};
  text-decoration: none;
  letter-spacing: 0.02em;
  transition: all ${theme.transitions.default};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: ${theme.colors.accentGradient};
    transition: left ${theme.transitions.slow};
    z-index: 0;
  }

  &:hover {
    color: white;
    border-color: ${theme.colors.primaryLight};
    box-shadow: ${theme.shadows.neon};
    transform: translateY(-3px);
  }

  &:hover::before {
    left: 0;
  }

  &:active {
    transform: translateY(-1px) scale(0.98);
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 4px;
  }

  span,
  i {
    z-index: 1;
    position: relative;
  }
`;
